// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BSuw","newExpiryDate":"styles_newExpiryDate__lkqif","footer":"styles_footer__24RGF"};